export default __webpack_public_path__ + "static/media/466.e86443d0.png";